import { render } from "./BaseTextarea.vue?vue&type=template&id=6aaffcb8"
import script from "./BaseTextarea.vue?vue&type=script&lang=js"
export * from "./BaseTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__